/* eslint-disable react/no-unused-prop-types */
import React, { useContext } from 'react'
import FeatureFlagsContext from 'contexts/FeatureFlagsContext'

type FeatureFlagHelperParams = {
  flagKey: string
  children: React.ReactElement
  enabled?: React.ReactElement
  disabled?: React.ReactElement
}

interface FeatureFlagHelper {
  Enabled: React.FC<FeatureFlagHelperParams>
  Disabled: React.FC<FeatureFlagHelperParams>
}

const Enabled: React.FC<FeatureFlagHelperParams> = ({ flagKey, children }) => {
  const featureFlags = useContext(FeatureFlagsContext)
  if (featureFlags[flagKey]) return children
  return null
}

const Disabled: React.FC<FeatureFlagHelperParams> = ({ flagKey, children }) => {
  const featureFlags = useContext(FeatureFlagsContext)
  if (!featureFlags[flagKey]) return children
  return null
}

const FeatureFlag: React.FC<FeatureFlagHelperParams> & FeatureFlagHelper = ({
  flagKey,
  enabled,
  disabled,
}) => {
  const featureFlags = useContext(FeatureFlagsContext)
  return featureFlags[flagKey] ? enabled : disabled
}

FeatureFlag.Enabled = Enabled
FeatureFlag.Disabled = Disabled

export default FeatureFlag
